import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export class TeamMemberPickerAnalytics extends BaseInvitePeopleAnalytics {
	teamMemberPickerViewed(attributes: {
		teamId: string;
		members: number;
		membersWithAccess: number;
		membersCapped: boolean;
	}) {
		this.fireScreen({
			name: AnalyticsActionSubject.TEAM_MEMBER_PICKER,
			attributes,
		});
	}

	teamMemberPickerContinueClicked(attributes: {
		teamId: string;
		members: number;
		membersWithAccess: number;
		selectedMembers: number;
		membersCapped: boolean;
	}) {
		this.fireUI({
			action: AnalyticsAction.CLICKED,
			actionSubject: AnalyticsActionSubject.BUTTON,
			actionSubjectId: 'teamMemberContinue',
			attributes: {
				source: 'teamMemberPicker',
				...attributes,
			},
		});
	}

	viewSlackTeamMembersFailed(code?: string, message?: string, status?: number) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.VIEW_SLACK_TEAM_MEMBERS,
			action: AnalyticsAction.FAILED,
			attributes: {
				code,
				message,
				status,
			},
		});
	}
}
